/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({
  description,
  lang,
  image: metaImage,
  title,
  pathname,
  blogURL,
}) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          social {
            twitter
          }
        }
      }
    }
  `);

  const image = typeof metaImage === 'string' && `${metaImage.split('?')[0]}`;
  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata && site.siteMetadata.title;
  const pageURL = blogURL
    ? `${site.siteMetadata.siteUrl}/${blogURL}`
    : site.siteMetadata.siteUrl;
  const canonical = pathname
    ? `${site.siteMetadata.siteUrl}/${pathname}`
    : site.siteMetadata.siteUrl;

  return (
    <Helmet
      defer={false}
      htmlAttributes={{
        lang,
      }}
      link={
        canonical
          ? [
              {
                rel: 'canonical',
                href: canonical,
              },
            ]
          : []
      }
      titleTemplate={defaultTitle ? `%s` : null}
    >
      {/* General tags */}
      <title>{title}</title>
      <meta name="image" content={`https:${image}`} />
      <meta name="description" content={metaDescription} />

      {/* Open graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={pageURL} />
      <meta property="og:image" content={`https:${image}`} />
      <meta property="og:image:width" content="1920" />
      <meta property="og:image:height" content="1080" />
      <meta property="og:description" content={metaDescription} />

      {/* Twitter card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      <meta name="twitter:image" content={`https:${image}`} />
      <meta name="twitter:description" content={metaDescription} />

      {/* Tools */}
      <meta
        name="google-site-verification"
        content="reuJjG9pF7AQtpi3zoO7604qv415n3HQyMbYjg0sLUc"
      />
    </Helmet>
  );
};

SEO.defaultProps = {
  lang: `en`,
  description: ``,
  image: null,
  pathname: '/',
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  pathname: PropTypes.string,
};

export default SEO;
